<template>
  <div class="combatant-slot">
    <PokemonDetail v-if="kind === 'pokemon'" v-bind="$attrs" :min-height="minHeight" />

    <ObstacleDetail v-else-if="kind === 'obstacle'" v-bind="$attrs" :min-height="minHeight" />

    <TrainerTile v-else-if="kind === 'trainer'" v-bind="$attrs" />

    <ObstacleTrainerCard v-else-if="kind === 'obstacle-trainer'" v-bind="$attrs" />

    <EncounterCard v-else-if="kind === 'encounter'" v-bind="$attrs" :min-height="minHeight" />

    <v-card v-else-if="kind === 'choose'" class="skin-pokemon-card combatant-choose-card" :height="minHeight" @click="$emit('open-picker')">
      <EnvironmentPill v-if="fightEnvironment" :environment="fightEnvironment" />
      <div class="combatant-choose-icon-wrap">
        <v-img src="@/assets/pic/web/pokeball_choose.png" contain class="combatant-choose-img" />
      </div>
      <div class="combatant-choose-overlay">
        <span class="combatant-choose-label">{{ $t('journey.combatantSlot.chooseLabel') }}</span>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.combatant-slot {
  /* Globalni pravidlo .container .v-card { height: 100% } (_card.sass) funguje jen pres
     nepreruseny v-card retezec predku se zadanou vyskou - tenhle wrapper drzi vysku dal. */
  height: 100%;
}
.combatant-choose-card {
  /* kotva pro "prilepenou" EnvironmentPill (position:absolute; left:0, drzi se sveho
     prvniho vyskytu v toku = vrsek) */
  position: relative;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  container-type: inline-size;
  transition: box-shadow 0.12s ease;
}
.combatant-choose-card:active {
  box-shadow: 0px 0px 3px rgba(0,0,0,0.5) inset !important;
}
@media (min-width: 960px) {
  .combatant-choose-card {
    /* Desktop: .battle-layout__row je auto-vysoky (BattleLayout.vue), takze mobilni
       minHeight="100%" by tu nemela vuci cemu se pocitat - pevnych 400px misto toho. */
    height: 400px !important;
  }
}
.combatant-choose-icon-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.combatant-choose-img {
  width: 70%;
  height: 70%;
}
.combatant-choose-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px;
  background: linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.0) 100%);
  text-align: center;
}
.combatant-choose-label {
  display: inline-block;
  color: #fff;
  font-weight: 700;
  font-size: clamp(13px, 6cqw, 20px);
  white-space: normal;
  word-break: normal;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.9);
}
</style>

<script>
import PokemonDetail from '@/components/pokemon/PokemonDetail';
import ObstacleDetail from '@/components/obstacle/ObstacleDetail';
import TrainerTile from '@/components/trainer/TrainerTile';
import ObstacleTrainerCard from '@/components/journey/positions/battle/ObstacleTrainerCard';
import EnvironmentPill from '@/components/journey/positions/battle/EnvironmentPill';
import EncounterCard from '@/components/journey/positions/battle/EncounterCard';

// Tenky wrapper nad existujicimi "combatant" komponentami - zadna nova logika, jen dispatch
// podle bojoveho modu. Viz claude/components/battle-skills.md.
export default {
  name: "CombatantSlot",
  components: {PokemonDetail, ObstacleDetail, TrainerTile, ObstacleTrainerCard, EnvironmentPill, EncounterCard},
  inheritAttrs: false,
  props: {
    kind: {type: String, required: true}, // 'pokemon' | 'obstacle' | 'trainer' | 'obstacle-trainer' | 'choose' | 'encounter'
    // Number (px) nebo "100%" (aktivni souboj, karta vyplnuje celou svou grid bunku)
    minHeight: {type: [Number, String], default: 400},
    fightEnvironment: {type: Object, default: null},
  },
}
</script>
